<template>
  <div class="add-drainage-activity-warp">
    <div class="content-box">
      <div class="page_title flex_between">
        <span>{{ doings_id ? "编辑券包" : "添加券包" }}</span>
        <el-button
          type="primary"
          style="width: 92px"
          @click="back"
          size="medium"
          >返回</el-button
        >
      </div>
      <div class="container">
        <div class="form-box">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <!-- 基本信息 -->
            <h3>基本信息</h3>
            <el-form-item label="券包名称" prop="group_coupon_name">
              <el-input
                v-model="ruleForm.group_coupon_name"
                style="width: 400px"
                type="textarea"
                clearable
                rows="2"
                placeholder="请输入"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <el-form-item label="券包描述" prop="group_coupon_desc">
              <el-input
                v-model="ruleForm.group_coupon_desc"
                style="width: 400px"
                type="textarea"
                rows="5"
                placeholder="请输入"
                maxlength="100"
              ></el-input>
            </el-form-item>

            <el-form-item label="banner设置" prop="banner_image">
              <UploadImg
                :f_thumb="ruleForm.banner_image"
                :f_thumb_str="ruleForm.banner_image_str"
                @emitImg="emitImg"
              ></UploadImg>
              <div class="prompt">建议尺寸750*640px</div>
            </el-form-item>

            <el-form-item label="背板色" prop="bg_color">
              <el-input
                v-model="ruleForm.bg_color"
                style="width: 400px"
                clearable
                placeholder="请输入"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <h3>优惠券信息</h3>

            <el-form-item label="诊疗优惠券" prop="console_coupon_id">
              <el-button
                :disabled="isLook"
                type="primary"
                style="padding: 7px 20px"
                @click="slectClinicCoupon(4)"
                >选择</el-button
              >
              <div class="youhuijuan-box">
                <div class="youhuijuan-item">
                  <div id="drag-item-box">
                    <draggable
                      v-model="lastMultipleSelection"
                      chosen-class="chosen"
                      force-fallback="true"
                      group="people"
                      animation="1000"
                      handle=".drag-handle"
                      @start="onStart3"
                      @end="onEnd3"
                    >
                      <transition-group>
                        <div
                          class="drag-item"
                          style="width: 200px"
                          v-for="(item, index) in lastMultipleSelection"
                          :key="index"
                        >
                          <i
                            v-if="!doings_id"
                            class="el-icon-close"
                            @click="deleteSpecialOffer(item, 4, index)"
                          ></i>
                          <div class="drag-handle">
                            <p
                              style="
                                width: 126px;
                                line-height: 20px;
                                height: 40px;
                                margin-bottom: 10px;
                              "
                            >
                              {{ item.coupon_name }}
                            </p>
                            <div class="content">
                              {{ item.use_condition }}
                            </div>
                            <div class="num" style="text-align: right">
                              X{{ item.num }}
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="商城优惠券" prop="shop_coupon_id">
              <el-button
                type="primary"
                style="padding: 7px 20px"
                :disabled="isLook"
                @click="slectClinicCoupon(2)"
                >选择</el-button
              >
              <div class="youhuijuan-box">
                <div class="youhuijuan-item">
                  <div id="drag-item-box">
                    <draggable
                      v-model="lastshopSelection"
                      chosen-class="chosen"
                      force-fallback="true"
                      group="people"
                      animation="1000"
                      handle=".drag-handle"
                      @start="onStart2"
                      @end="onEnd2"
                    >
                      <transition-group>
                        <div
                          class="drag-item"
                          style="width: 200px"
                          v-for="(element, index) in lastshopSelection"
                          :key="index"
                        >
                          <i
                            v-if="!doings_id"
                            class="el-icon-close"
                            @click="deleteSpecialOffer(element, 2, index)"
                          ></i>
                          <div class="drag-handle">
                            <p
                              style="
                                width: 126px;
                                line-height: 20px;
                                height: 40px;
                                margin-bottom: 10px;
                              "
                            >
                              {{ element.coupon_name }}
                            </p>
                            <div class="content">
                              {{ element.use_condition }}
                            </div>
                            <div class="num" style="text-align: right">
                              X{{ element.num }}
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>
            </el-form-item>

            <div class="btn-box">
              <el-form-item>
                <el-button @click="resetForm('ruleForm')">取消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >确定</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 选择诊疗优惠卷弹窗 -->
    <el-dialog
      title="选择优惠券"
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="handleClose"
    >
      <div class="">
        <div class="serch-box">
          <p style="text-align: left; padding-left: 20px">
            优惠券名称：<el-input
              v-model="serch.coupon_name"
              style="width: 250px"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
            <el-button
              type="primary"
              @click="getClickOrShopCoupon(couponFrom)"
              style="margin-left: 20px"
              >查询</el-button
            >
          </p>
        </div>
        <!-- 诊疗优惠券 -->
        <el-table
          v-if="couponFrom == 4"
          ref="multipleTable"
          :data="couponTableDiaData"
          tooltip-effect="dark"
          style="width: 100%"
          height="400px"
          border
          v-loading="couponDiaTableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          >
          </el-table-column>
          <el-table-column
            v-for="item in couponTableDiaHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'coupon_from'">
                {{ scope.row[item.prop] | couponFromText }}
              </div>
              <div v-else-if="item.prop == 'message'">
                {{ scope.row.use_condition }}
              </div>

              <div v-else-if="item.prop == 'use_time'">
                <div v-if="scope.row['time_limit'] == 2">
                  {{ scope.row["time_start"] | dateFormat }} -
                  {{ scope.row["time_end"] | dateFormat }}
                </div>
                <div v-else>领取后{{ scope.row["time_days"] }}有效</div>
              </div>

              <div v-else-if="item.prop == 'show_time'">
                {{ scope.row["show_start_time"] | dateFormat }} -
                {{ scope.row["show_end_time"] | dateFormat }}
              </div>
              <div v-else-if="item.prop == 'total'">
                {{ scope.row[item.prop] | totalText }}
              </div>
              <div v-else-if="item.prop == 'is_share'">
                {{ scope.row[item.prop] | isShareText }}
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="张数" prop="num">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.num"
                :min="1"
                :step="1"
                size="small"
                :controls="false"
              ></el-input-number>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 商品优惠券 -->
        <el-table
          v-if="couponFrom == 2"
          ref="multipleTable"
          :data="couponTableDiaData"
          tooltip-effect="dark"
          style="width: 100%"
          height="400px"
          border
          v-loading="couponDiaTableLoading"
          :header-cell-style="{ background: '#F5F5F5' }"
          :row-key="getRowKeysShop"
          @selection-change="handleSelectionChangeShop"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          >
          </el-table-column>
          <el-table-column
            v-for="item in couponTableDiaHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'coupon_from'">
                {{ scope.row[item.prop] | couponFromText }}
              </div>
              <div v-else-if="item.prop == 'message'">
                {{ scope.row.use_condition }}
              </div>

              <div v-else-if="item.prop == 'use_time'">
                <div v-if="scope.row['time_limit'] == 2">
                  {{ scope.row["time_start"] | dateFormat }} -
                  {{ scope.row["time_end"] | dateFormat }}
                </div>
                <div v-else>领取后{{ scope.row["time_days"] }}有效</div>
              </div>

              <div v-else-if="item.prop == 'show_time'">
                {{ scope.row["show_start_time"] | dateFormat }} -
                {{ scope.row["show_end_time"] | dateFormat }}
              </div>
              <div v-else-if="item.prop == 'total'">
                {{ scope.row[item.prop] | totalText }}
              </div>
              <div v-else-if="item.prop == 'is_share'">
                {{ scope.row[item.prop] | isShareText }}
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="张数" prop="num">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.num"
                :min="1"
                :step="1"
                size="small"
                :controls="false"
              ></el-input-number>
            </template>
          </el-table-column> -->
        </el-table>

        <!-- 分页 -->
        <pagination
          :total="pagination.totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getClickOrANDShopCoupon"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogVisible">取 消</el-button>
        <el-button type="primary" @click="confirmSpecialOffer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
import UploadImg from "@/components/uploadImg/index";
import draggable from "vuedraggable";
import common from "@/api/common";
import ChooseDoctor from "@/components/chooseDoctor/index";
export default {
  components: {
    Pagination,
    UploadImg,
    draggable,
    ChooseDoctor,
  },
  data() {
    return {
      dialogVisible: false, // 诊疗优惠卷弹窗
      couponDiaTableLoading: false,
      doings_id: "",
      ruleForm: {
        group_coupon_name: "",
        group_coupon_desc: "",
        banner_image: "",
        banner_image_str: "",
        bg_color: "",
        shop_coupon_id: [],
        console_coupon_id: [],
      },

      serch: {
        coupon_name: "", // 搜索诊疗优惠卷
        shop_name: "", // 搜索商城优惠卷
      },
      drag: false,
      pagination: {
        totalNum: 0,
        page: 1,
        pageNumber: 10,
      },

      couponTableDiaHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "160",
          align: "center",
          fixed: false,
        },
        // {
        //   label: "优惠券分类",
        //   prop: "coupon_from",
        //   width: "auto",
        //   align: "center",
        //   fixed: false,
        // },
        {
          label: "使用条件",
          prop: "message",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "发放总数",
          prop: "total",
          width: "80",
          align: "center",
          fixed: false,
        },
        {
          label: "使用时间",
          prop: "use_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取时间",
          prop: "show_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "是否可分享",
          prop: "is_share",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponFrom: null,
      couponTableDiaData: [], // 诊疗优惠卷列表
      shopSelectionDiaData: [], // 商城优惠卷被选中的列表
      lastshopSelection: [], // 最终商城优惠卷被选中的列表
      multipleSelection: [], // 诊疗药品卷被选中的列表
      lastMultipleSelection: [], // 诊疗药品卷被选中的列表
      rules: {
        group_coupon_name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        banner_image: [
          {
            required: true,
            message: "请上传",
          },
        ],
        bg_color: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
      },
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    couponFromText(val) {
      switch (val) {
        case 1:
          return "诊疗优惠劵";
        case 2:
          return "商城优惠券";
        case 3:
          return "诊疗优惠劵";
        case 4:
          return "诊疗优惠劵";
      }
    },
    isShareText(val) {
      switch (val) {
        case 0:
          return "不可分享";
        case 1:
          return "可分享";
      }
    },
    totalText(val) {
      switch (val) {
        case -1:
          return "无限";
        default:
          return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    isLook() {
      return this.$route.query.group_id != -1;
    },
  },
  created() {
    if (this.routeQuery.group_id != -1) {
      this.grantCouponGroupInfo();
    }
  },
  methods: {
    emitImg(data) {
      let { path, pic } = data;
      this.ruleForm.banner_image = pic;
      this.ruleForm.banner_image_str = path;
      this.$refs["ruleForm"].validateField(["banner_image"]);
    },
    // 查询详情
    async grantCouponGroupInfo() {
      let params = {
        group_id: this.routeQuery.group_id,
      };
      await marketing.grantCouponGroupInfo(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          let {
            console_coupon,
            group_coupon_desc,
            group_coupon_name,
            shop_coupon,
            bg_color,
            banner_image,
            banner_image_str,
          } = data.info;
          this.ruleForm = {
            group_coupon_name: group_coupon_name,
            group_coupon_desc: group_coupon_desc,
            shop_coupon_id: shop_coupon,
            console_coupon_id: console_coupon,
            bg_color: bg_color,
            banner_image: banner_image,
            banner_image_str: banner_image_str,
          };
          this.lastshopSelection = shop_coupon;
          this.lastMultipleSelection = console_coupon;
        }
      });
    },
    submitForm(formName) {
      console.log(" this.ruleForm", this.ruleForm);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let len =
            this.ruleForm["shop_coupon_id"].length +
            this.ruleForm["console_coupon_id"].length;
          if (len < 2) {
            this.$message.warning("优惠券不可少于2张");
            return;
          }
          const loading = this.$loading();
          let interfaceName =
            this.routeQuery.group_id == -1
              ? "createPlatformCouponGroup"
              : "updatePlatformCouponGroup";
          let params =
            this.routeQuery.group_id == -1
              ? Object.assign({}, this.ruleForm)
              : Object.assign(
                  { group_id: this.routeQuery.group_id },
                  this.ruleForm
                );

          marketing[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.back();
              }
              loading.close();
            })
            .catch((err) => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onStart2() {
      this.drag = true;
    },
    onEnd2() {
      this.drag = false;
      // console.log("lastshopSelection", this.lastshopSelection);
      let shopCouponId = [];
      this.lastshopSelection.forEach((item) => {
        shopCouponId.push(`${item.coupon_data_id}|${item.num}`);
        if (shopCouponId.length > 0) {
          this.ruleForm.shop_coupon_id = shopCouponId.join(",");
        } else {
          this.ruleForm.shop_coupon_id = "";
        }
      });
    },
    onStart3() {
      this.drag = true;
    },
    onEnd3() {
      this.drag = false;
      let clinicDouponid = [];
      this.lastMultipleSelection.forEach((item) => {
        clinicDouponid.push(`${item.coupon_data_id}|${item.num}`);
      });
      if (clinicDouponid.length > 0) {
        this.ruleForm.console_coupon_id = clinicDouponid.join(",");
      } else {
        this.ruleForm.console_coupon_id = "";
      }
    },
    // 选择诊疗优惠卷弹窗
    slectClinicCoupon(couponFrom) {
      //couponFrom  1查诊疗药品券，2查商城优惠券，3诊疗问诊券 4全部
      this.couponFrom = couponFrom;
      this.dialogVisible = true;
      this.getClickOrShopCoupon(couponFrom);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    getRowKeys(row) {
      return row.coupon_data_id;
    },
    getRowKeysShop(row) {
      return row.coupon_data_id;
    },
    handleSelectionChangeShop(val) {
      this.shopSelectionDiaData = val;
    },
    getClickOrANDShopCoupon() {
      this.getClickOrShopCoupon(this.couponFrom);
    },
    // 获取优惠卷列表
    getClickOrShopCoupon(couponFrom) {
      // coupon_name  1 诊疗药品券  2 商城优惠卷 3诊疗问诊券 4全部
      let params = {
        coupon_name: this.serch.coupon_name, // 商城优惠卷名称
        coupon_from: couponFrom, // 1 诊疗药品券  2 商城优惠卷 3诊疗问诊券 this.ruleForm
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber,
      };
      this.couponDiaTableLoading = true;
      common.getClickOrShopCoupon(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.pagination.totalNum = data.total;
          this.couponTableDiaData = data.list.map((item) => {
            item.num = 1;
            return item;
          });

          this.couponDiaTableLoading = false;
        }
      });
    },
    handleClose() {
      this.couponFrom = null;
      this.couponDiaTableLoading = false;
      this.serch.coupon_name = "";
      this.dialogVisible = false;
      this.couponTableDiaData = [];
      this.pagination = {
        totalNum: 0,
        pageNumber: 10,
        page: 1,
      };
    },
    closeDialogVisible() {
      this.dialogVisible = false;
      this.handleClose();
    },
    confirmSpecialOffer() {
      if (this.couponFrom == 4) {
        // 去重 诊疗优惠卷被选中的列表
        let clinicDouponid = [];
        this.multipleSelection.forEach((item) => {
          let exsit = this.lastMultipleSelection.every((Sitem) => {
            return Sitem.coupon_data_id !== item.coupon_data_id;
          });

          // console.log("exsit", exsit);

          if (exsit && this.lastMultipleSelection.length < 25) {
            this.lastMultipleSelection.push(item);
          } else {
            let index = _.findIndex(this.lastMultipleSelection, [
              "coupon_data_id",
              item.coupon_data_id,
            ]);
            this.lastMultipleSelection.splice(index, 1, item);
          }
        });

        this.lastMultipleSelection.forEach((item) => {
          let obj = {
            coupon_data_id: item.coupon_data_id,
            num: item.num,
          };
          clinicDouponid.push(obj);
        });
        if (clinicDouponid.length > 0) {
          this.ruleForm.console_coupon_id = clinicDouponid;
          // console.log( ' this.ruleForm.console_coupon_id',this.ruleForm.console_coupon_id)
        } else {
          this.ruleForm.console_coupon_id = [];
        }
      } else if (this.couponFrom == 2) {
        // 去重商城优惠卷被选中的列表
        let shopCouponId = [];
        this.shopSelectionDiaData.forEach((items) => {
          let exsit = this.lastshopSelection.every((Sitem) => {
            return Sitem.coupon_data_id !== items.coupon_data_id;
          });
          // console.log("exsit", exsit);
          if (exsit && this.lastshopSelection.length < 25) {
            this.lastshopSelection.push(items);
          } else {
            let index = _.findIndex(this.lastshopSelection, [
              "coupon_data_id",
              item.coupon_data_id,
            ]);
            this.lastshopSelection.splice(index, 1, item);
          }
        });
        this.lastshopSelection.forEach((item) => {
          let obj = {
            coupon_data_id: item.coupon_data_id,
            num: item.num,
          };
          shopCouponId.push(obj);
          if (shopCouponId.length > 0) {
            this.ruleForm.shop_coupon_id = shopCouponId;
            // console.log( ' this.ruleForm.shop_coupon_id',this.ruleForm.shop_coupon_id)
          } else {
            this.ruleForm.shop_coupon_id = [];
          }
        });
      }
      this.dialogVisible = false;
      this.handleClose();
    },
    // 删除优惠卷
    deleteSpecialOffer(item, couponFrom, couponIndex) {
      if (this.isLook) {
        return;
      }
      if (couponFrom == 4) {
        // 删除诊疗优惠卷
        let clinicDouponid = [];
        this.lastMultipleSelection.splice(couponIndex, 1);
        this.lastMultipleSelection.forEach((item) => {
          clinicDouponid.push(item.coupon_data_id);
        });
        if (clinicDouponid.length > 0) {
          this.ruleForm.console_coupon_id = clinicDouponid.join(",");
        } else {
          this.ruleForm.console_coupon_id = "";
        }
      } else if (couponFrom == 2) {
        // 删除商城优惠卷
        this.lastshopSelection.splice(couponIndex, 1);
        let shopCouponId = [];
        this.lastshopSelection.forEach((item) => {
          shopCouponId.push(item.coupon_data_id);
          if (shopCouponId.length > 0) {
            this.ruleForm.shop_coupon_id = shopCouponId.join(",");
          } else {
            this.ruleForm.shop_coupon_id = "";
          }
        });
      }
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
  

  <style lang="scss">
.add-drainage-activity-warp {
  .content-box {
    border-radius: 5px;
    .page_title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 24px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 18px;
      text-align: left;
      background: #fbfbfb;
      font-weight: 600;
    }
    .container {
      margin: 20px;
      box-sizing: border-box;
      background-color: #ffffff;
      min-height: calc(100vh - 140px);
      border-radius: 5px;
      padding: 20px;
      .form-box {
        text-align: left;
        h3 {
          margin-bottom: 20px;
        }
        //  border: solid 1px red;
        .form-item-flex {
          display: flex;
        }
        .head-portrait {
          img {
            width: 150px;
            height: 100px;
          }
        }
        .youhuijuan-box {
          .youhuijuan-item {
            width: 815px;
            margin-top: 10px;
            .drag-item {
              width: 150px;
              height: 120px;
              text-align: left;
              margin-right: 13px;
              margin-bottom: 13px;
              padding: 0 10px;
              box-sizing: border-box;
              background-color: #f1efef;
              position: relative;
              .el-icon-close {
                position: absolute;
                right: 5px;
                top: 5px;
                cursor: pointer;
              }
              p {
                margin: 5px 0 0 0;
                font-weight: 600;
              }
              .content {
                line-height: 24px;
              }
            }
          }
        }
        .btn-box {
          //   border:solid 1px red;
          text-align: center;
          padding-top: 30px;
        }
      }
    }
  }
  .other-config-warp {
    .other-config-box {
      text-align: left;
      height: 480px;
      padding: 30px 0 20px 0;
      border-bottom: solid 1px #ebe4e4;
    }
  }
}
.add-drainage-activity-warp {
  // .el-pagination{
  //    text-align: right;
  //    margin-bottom: 30px;
  // }
  .el-form-item__content {
    height: auto;
  }
  .form-box {
    .el-form-item__content {
      height: auto;
    }

    .youhuijuan-item {
      width: 800px;
      #drag-item-box {
        //    display: flex;
        .el-icon-close {
          position: absolute;
          right: 0;
          top: 0;
          padding: 10px;
        }
      }
      #drag-item-box > div > span {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}
.cus-drainageActivity-dotor {
  width: 900px !important;
  .el-message-box__message {
    height: 400px;
    overflow-y: auto;
    p {
      .til {
        color: #f56c6c;
      }
      .box {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }
  }
}
</style>
  